import { Button } from '@material-ui/core';
import React, { useState } from 'react';

const AOBClearanceInfo = ({ aob_cleared, account, member, onRefresh }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const sendAOBLink = async () => {
    setIsLoading(true);
    setMessage('');
    setMessageType('');

    try {
      const response = await window.sch.post(
        '/api/consent/get_aob_prefilled_url',
        {
          account,
          member,
        }
      );

      setMessage(response.msg || 'AOB link sent successfully');
      setMessageType('success');
    } catch (err) {
      setMessage(err.message || 'Failed to send AOB link');
      setMessageType('error');
    } finally {
      setIsLoading(false);
    }
  };

  const containerStyle = {
    borderLeft: '4px solid green',
    fontSize: 14,
    // backgroundColor: 'lightgreen',
    marginBottom: 8,
    padding: 8,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 16,
  };

  const leftColumnStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  };

  const rightColumnStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
  };

  const buttonStyle = {
    opacity: isLoading ? 0.6 : 1,
    cursor: isLoading ? 'not-allowed' : 'pointer',
  };

  const messageStyle = {
    marginTop: 8,
    padding: 4,
    fontSize: 12,
    color: messageType === 'error' ? 'red' : 'green',
    backgroundColor: messageType === 'error' ? '#ffebee' : '#e8f5e8',
    border: `1px solid ${messageType === 'error' ? '#ffcdd2' : '#c8e6c8'}`,
    borderRadius: 4,
  };

  const getStatusStyle = (status) => {
    const baseStyle = {
      padding: '2px 8px',
      borderRadius: '4px',
    };
    switch (status) {
      case 'OBTAINED':
        return { ...baseStyle, backgroundColor: 'green', color: 'white' };
      case 'PENDING COMPLETION':
        return { ...baseStyle, backgroundColor: 'yellow', color: 'black' };
      case 'NOT OBTAINED':
        return { ...baseStyle, backgroundColor: 'red', color: 'white' };
      default:
        return baseStyle;
    }
  };

  if (aob_cleared.aob_cleared === true) {
    return (
      <div style={containerStyle}>
        <div style={leftColumnStyle}>
          <div>
            <strong>Assignment of Benefits (AOB)</strong>
            <br />
            AOB Status: <b style={getStatusStyle('OBTAINED')}>OBTAINED</b>
          </div>
        </div>
        <div style={rightColumnStyle}>
          <Button variant="outlined" onClick={onRefresh}>
            Refresh AOB Status
          </Button>
        </div>
      </div>
    );
  }

  if (typeof aob_cleared.last_invite === 'string') {
    return (
      <div style={containerStyle}>
        <div style={leftColumnStyle}>
          <div>
            <strong>Assignment of Benefits (AOB)</strong>
            <br />
            AOB Status:{' '}
            <b style={getStatusStyle('PENDING COMPLETION')}>
              PENDING COMPLETION
            </b>
            <br />
            Last sent date {aob_cleared.last_invite}
          </div>
          {message && <div style={messageStyle}>{message}</div>}
        </div>
        <div style={rightColumnStyle}>
          {aob_cleared.allow_send_aob_link ? (
            <Button
              onClick={sendAOBLink}
              variant="contained"
              disabled={isLoading}
              style={buttonStyle}>
              {isLoading ? 'Sending...' : 'Send AOB Link'}
            </Button>
          ) : (
            <div>
              Unable to re-send AOB due to patient unsubscribed or no valid
              SMS/Email
            </div>
          )}
          <br />
          <Button variant="outlined" onClick={onRefresh}>
            Refresh AOB Status
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={leftColumnStyle}>
        <div>
          <strong>Assignment of Benefits (AOB)</strong>
          <br />
          AOB Status: <b style={getStatusStyle('NOT OBTAINED')}>NOT OBTAINED</b>
        </div>
        {message && <div style={messageStyle}>{message}</div>}
      </div>
      <div style={rightColumnStyle}>
        {aob_cleared.allow_send_aob_link ? (
          <Button
            onClick={sendAOBLink}
            variant="contained"
            disabled={isLoading}
            style={buttonStyle}>
            {isLoading ? 'Sending...' : 'Send AOB Link'}
          </Button>
        ) : (
          <div>
            Unable to send AOB due to patient unsubscribed or no valid SMS/Email
          </div>
        )}
        <br />
        <Button variant="outlined" onClick={onRefresh}>
          Refresh AOB Status
        </Button>
      </div>
    </div>
  );
};

export default AOBClearanceInfo;
